// DRF token auth: localStorage stores the raw token string, which has no
// expiry. The previous code read `token.expiration` off that string (always
// undefined), so the expiry branch was dead. Return the stored token as-is.
export const getToken = (): string | null => {
  return localStorage.getItem("token");
};
